import React from "react";
import PropTypes from "prop-types";
import { Img } from "components";

const DefaultMoney = React.forwardRef(
  (
    {
      inputClassName = "",
      className = "",
      name = "",
      label = "",
      key="",
      checked = false,
      onChange,
      id = "radio_id",
      ...restProps
    },
    ref
  ) => {
    const [value, setValue] = React.useState(checked);

    const handleChange = (event) => {
      setValue(event.target.checked);
      if (onChange) onChange(!!event?.target?.checked);
    };

    return (
      <>
        <div className={`${className} defaultmoney relative`} key={key?key:Math.random()} style={{borderColor:"#E6E6E6"}}>
          <input
            className={`${inputClassName} invisible absolute top-0 ltr:left-0 rtl:right-0`}
            ref={ref}
            type="radio"
            name={name}
            aria-checked={!!value}
            checked={checked}
            onChange={handleChange}
            {...restProps}
            id={id}
          />
          <label
            htmlFor={id}
            className={`cursor-pointer border border-solid flex items-center justify-center w-full px-3 py-[5px] rounded-lg`}
          >
            <div className="w-auto text-[18px] font-medium leading-[24px] text-center font-['Unbounded'] text-[var(--Blacks-900,#1A1A1A)] sm:text-[16px]">
             <Img src="images/Groupsar2.svg" alt="SAR" className="w-4 h-4 inline-block" /> {label}
            </div>
          </label>
        </div>
      </>
    );
  }
);

DefaultMoney.propTypes = {
  inputClassName: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

export { DefaultMoney };
